import ContactProfileImage from '@app/components/ContactProfileImage'
import SearchBar from '@app/components/SearchBar'
import { ITeamMember } from '@app/models/TeamMember'
import { bindFunctions } from '@app/utils/class'
import { List } from 'immutable'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { actionCreators, ITeamViewState } from '../modules/teamView'

interface IComponentState {
  filterText: string
}

type IComponentProps = ITeamViewState &
  RouteComponentProps<{ id: string }> &
  typeof actionCreators

class TeamMembers extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)

    this.state = {
      filterText: '',
    }
  }

  public render() {
    return (
      <div key={this.props.match.params.id}>
        <div className='mx-2'>{this._renderMembers()}</div>
      </div>
    )
  }

  private _renderMembers() {
    const filteredConnections = this.props.item.members
      .filter((item: any) => {
        return this.state.filterText
          ? item.name
              .toLowerCase()
              .indexOf(this.state.filterText.toLowerCase()) > -1
          : true
      })
      .toList()

    return (
      <div>
        <SearchBar
          placeholder='Filter members...'
          size='sm'
          value={this.state.filterText}
          onChange={(e) => {
            this.setState({
              filterText: e,
            })
          }}
        />
        {this._renderMemberList(filteredConnections)}
      </div>
    )
  }

  private _renderMemberList(list: List<ITeamMember>) {
    if (list.size === 0) {
      return <div>No Members</div>
    }

    const connections = list.map((contact: any) => {
      if (contact === undefined) {
        return null
      }

      return (
        <div className='my-2' style={{ width: '300px' }} key={contact.userId}>
          <a
            className='d-flex flex-row'
            target='_blank'
            rel='noreferrer'
            style={{ color: 'black' }}
            href={`/connection/${contact.userId}`}
          >
            <ContactProfileImage contact={contact.userId} size={70} />
            <div className='ml-2 align-self-center'>
              <div>
                <strong>{contact.name}</strong>
              </div>
            </div>
          </a>
        </div>
      )
    })

    return (
      <div className='d-flex flex-wrap justify-content-between'>
        {connections}
      </div>
    )
  }
}

export default withRouter(TeamMembers)
